import { renderAmount, renderDate, Transaction } from '@enter/core';
import React from 'react';
import * as S from './billing-timeline-table.styles';

interface ITransactionDetailProps {
    transaction: Transaction;
}

export const TransactionDetail: React.FunctionComponent<ITransactionDetailProps> = (
    props: ITransactionDetailProps,
): React.ReactElement => {
    const { transaction } = props;
    return (
        <S.Table key={transaction.id} expand={true}>
            <S.TBody>
                <S.TR>
                    <S.TH>Date</S.TH>
                    <S.TD>{renderDate(transaction.created)}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Amount</S.TH>
                    <S.TD>{renderAmount(transaction.amount)}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Refund</S.TH>
                    <S.TD>{transaction.refund?.amount?.amount || '--'}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Billed by</S.TH>
                    <S.TD>{transaction.billedByDescriptor}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Status</S.TH>
                    <S.TD>{transaction.status}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Memo</S.TH>
                    <S.TD>{transaction.memo}</S.TD>
                </S.TR>
            </S.TBody>
        </S.Table>
    );
};
